import { z } from 'zod';
import { isoDateTimeSchema, uuidSchema } from './common.js';
import { mediaPurposeSchema, mediaStatusSchema } from './enums.js';
export const ACCEPTED_IMAGE_MIME_TYPES = [
    'image/jpeg',
    'image/png',
    'image/webp',
    'image/heic',
    'image/heif',
];
export const acceptedImageMimeTypeSchema = z.enum(ACCEPTED_IMAGE_MIME_TYPES);
export const ACCEPTED_AUDIO_MIME_TYPES = [
    'audio/webm',
    'audio/ogg',
    'audio/mp4',
    'audio/mpeg',
    'audio/wav',
];
export const acceptedAudioMimeTypeSchema = z.enum(ACCEPTED_AUDIO_MIME_TYPES);
export const uploadIntentRequestSchema = z.object({
    fileName: z.string().min(1).max(255),
    mimeType: z.string().min(1).max(100),
    sizeBytes: z.number().int().positive(),
    purpose: mediaPurposeSchema.default('RECIPE'),
});
export const uploadIntentResponseSchema = z.object({
    assetId: uuidSchema,
    uploadUrl: z.string().url(),
    method: z.enum(['PUT', 'POST']),
    headers: z.record(z.string()),
    expiresAt: isoDateTimeSchema,
    maxBytes: z.number().int(),
});
export const mediaVariantSchema = z.object({
    name: z.enum(['thumb', 'small', 'medium', 'large', 'original']),
    url: z.string(),
    width: z.number().int(),
    height: z.number().int(),
    format: z.string(),
    bytes: z.number().int(),
});
export const mediaAssetSchema = z.object({
    id: uuidSchema,
    ownerId: uuidSchema,
    purpose: mediaPurposeSchema,
    status: mediaStatusSchema,
    mimeType: z.string(),
    sizeBytes: z.number().int(),
    width: z.number().int().nullable(),
    height: z.number().int().nullable(),
    altText: z.string().nullable(),
    url: z.string().nullable(),
    thumbnailUrl: z.string().nullable(),
    variants: z.array(mediaVariantSchema),
    exifStripped: z.boolean(),
    /** `#rrggbb` of the picture's dominant colour, computed once by the media worker. */
    dominantColor: z.string().nullable().optional(),
    expiresAt: isoDateTimeSchema.nullable(),
    createdAt: isoDateTimeSchema,
    errorMessage: z.string().nullable(),
});
/**
 * Keep a picture that was uploaded for something short-lived: a photo of a cookbook page is an
 * AI input and is deleted after the retention time – copied, it can become the recipe's picture.
 */
export const mediaCopyRequestSchema = z.object({
    purpose: z.enum(['RECIPE']).default('RECIPE'),
});
/** Fetch a picture from the web (a video's still) as a recipe picture; the server fetches it safely. */
export const mediaImportUrlRequestSchema = z.object({
    url: z.string().trim().url().max(2048),
    purpose: z.enum(['RECIPE']).default('RECIPE'),
});
export const completeUploadRequestSchema = z.object({
    altText: z.string().max(300).nullable().optional(),
});
export const mediaTransformRequestSchema = z.object({
    rotate: z.union([z.literal(0), z.literal(90), z.literal(180), z.literal(270)]).default(0),
    crop: z
        .object({
        x: z.number().int().min(0),
        y: z.number().int().min(0),
        width: z.number().int().positive(),
        height: z.number().int().positive(),
    })
        .nullable()
        .default(null),
    altText: z.string().max(300).nullable().optional(),
});
//# sourceMappingURL=media.js.map